import inquiryprice from '@/view/inquiry-price';

const price = {
    install:function (Vue) {
        Vue.component('price',inquiryprice)
    }
}
export default price;